module.exports = __webpack_public_path__ + "static/media/close_grey_img.388659ca.svg";